import i18n from 'translations'

export const getTitle = ({ isEdit, prefix }) => {
  const action = isEdit ? i18n.t('global:Edit') : i18n.t('global:Add')

  return i18n.t(prefix.concat('Form:title'), { action })
}
